// Profile conversion benchmarks from Amplitude. Update when product refreshes metrics.
export const COACH_PLUS_CONVERSION_MULTIPLIER = '5x'
export const COACH_PLUS_PROFILE_CONVERSION_RATE = '8%'
export const STANDARD_PROFILE_CONVERSION_RATE = '1.6%'
